import { useState } from "react";

export function useSession() {
  const [token, setToken] = useState(localStorage.getItem("sessionToken") || "");
  const [tenantCode, setTenantCode] = useState(localStorage.getItem("tenantCode") || "");
  const [userToken, setUserToken] = useState(localStorage.getItem("userSessionToken") || "");
  const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail") || "");
  
  const saveTenant = (t, c) => {
    localStorage.setItem("sessionToken", t);
    localStorage.setItem("tenantCode", c);
    setToken(t);
    setTenantCode(c);
  };
  
  const saveUser = (ut, email) => {
    localStorage.setItem("userSessionToken", ut);
    localStorage.setItem("userEmail", email);
    setUserToken(ut);
    setUserEmail(email);
  };
  
  const clear = () => {
    ["sessionToken","tenantCode","userSessionToken","userEmail"].forEach(k => localStorage.removeItem(k));
    setToken("");
    setTenantCode("");
    setUserToken("");
    setUserEmail("");
  };
  
  const authHeaders = () => {
    if (userToken) return { "X-User-Session-Token": userToken };
    if (token) return { "X-Session-Token": token };
    return {};
  };
  
  const isLoggedIn = () => !!(userToken || token);
  const isUser = () => !!userToken;
  
  return { token, tenantCode, userToken, userEmail, saveTenant, saveUser, clear, authHeaders, isLoggedIn, isUser };
}
